import React from "react";
import { RiCloseCircleLine4 } from "../../icons/RiCloseCircleLine4";
import "./style.css";

export const RiCloseCircleLine4Wrapper = () => {
  return <RiCloseCircleLine4 className="ri-close-circle-line-4" />;
};
